import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const HealthMetrics = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 health-metrics">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                            <Trans>Team <br/>Health Metrics <br/>Monitoring</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                            <Trans>Assist your employees in tracking vital health metrics <br/>and celebrate every achieved wellness milestone.</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                    <Trans>Heartbeat Tracking</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Heart Rate Monitoring</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><ul><li><Trans>Empower your employees to effortlessly monitor their heart rates with our easy-to-use Vantage Fit app.</Trans></li><li><Trans>Simplify heart rate tracking for your staff with phone's camera and advanced analysis.</Trans></li></ul></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706185071/VantageFit/2023/health_metrics-heart_rate`)} fetchPriority="high" alt="Heart Rate Monitoring" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label orange-font">
                                    <Trans>Weight Management</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Weight Tracker</Trans></h2>
                                    <p className='section-para font-weight-normal'><Trans>Support your team in setting and achieving weight goals with our efficient tracking system.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img px-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706185071/VantageFit/2023/health_metrics-weight`)} loading='lazy' alt="Weight Tracker" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative container">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat4">Informed Decisions for&nbsp;<span className="charmonman green-clr">Better Health</span></Trans>&nbsp;!</h2>
                    <div className="section-para text-center no-br"><Trans>Leverage the potential of data to tailor your employees' wellness journey and attain health goals.</Trans></div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Empower Your Team with Health Insights</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white no-br">
                        <Trans>Equip your employees to delve into their well-being! <br/>Let's embark on this journey together.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HealthMetrics;
